// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__2B7uQ","success":"FinishedQuiz_success__1QVuH","error":"FinishedQuiz_error__3Q-T4"};